<template>
  <nav class="navbar navbar-expand-lg scrolling-navbar" style="background-color:#d6d8db">

    <div class="container-fluid ">
      
      <p class="title" style="margin: 0px 0px !important;">{{$store.getters.PageName}}</p>
      
      
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end" >
        <b-dropdown variant="dark" style="z-index:1001">
          <template #button-content  >
            <b-icon icon="person-circle" aria-hidden="true" ></b-icon>  {{username}}
          </template>
          <b-dropdown-item to="/dashboard/Profile"> Profile</b-dropdown-item>
          <b-dropdown-item v-if="false">Settings</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button variant="danger" @click="onLogout">
            <b-icon icon="box-arrow-right" aria-hidden="true" ></b-icon>
            Logout
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>


  </nav>

</template>
<script>
  export default {
  
    computed: {
      
      username () {
        // console.log(this.$store.getters.user)
        return !this.$store.getters.user ? false : this.$store.getters.user[0].username
      }
    },
  
    created() {
     
      //if(localStorage.getItem('page_name')) {
      // console.log(localStorage.getItem('page_name'))
      // this.nameDashboard = localStorage.getItem('page_name')
     // }
  
      this.$store.dispatch('fetchUser')

    },
    data () {
      return {
        profile:false,
        //nameDashboard:'',
        activeNotifications: false
      }
    },
    methods: {
      
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      onLogout() {
        //console.log("here")
        this.$store.dispatch('logout')

      },
      
    
    }
  }

</script>
<style>
.dropdown-menu {
  top: 100% !important;
  min-width: 7rem;
}
.navbar .btn {
  margin: 0px 0px;
}
.dropdown-item.active{
  background-color: #00948a !important;
}
.title{
  margin: 0px !important;
  font-size: 15px;
  color: #000;
  font-size: 20px;
  font-weight: 500;
}
</style>
